import React, { useEffect, useState } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './Components/Home';
import ArtistSubmission from './Artist/Art';
import ArtworkPage from './Artist/ArtworkPage';
import ArtistPage from './Artist/ArtistPage';
import Animetest from './Artist/Anime';
import theme from './Theme';
import LoadingScreen from './Loading';

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only show loading screen for home page
    if (location.pathname === '/') {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000); // You can adjust timing or hook this to content load

      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [location.pathname]);

  return (
    <div className='cursor'>
      <MuiThemeProvider theme={theme}>
        {loading && location.pathname === '/' ? (
          <LoadingScreen onLoaded={() => setLoading(false)} />
        ) : (
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/Anime-Art-Hub' element={<ArtistSubmission />} />
            <Route
              path='/Anime-Art-Hub/artwork/:id'
              element={<ArtworkPage />}
            />
            <Route
              path='/Anime-Art-Hub/artist/:wallet'
              element={<ArtistPage />}
            />
            <Route path='/Animetest' element={<Animetest />} />
          </Routes>
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default App;
